module.exports = __webpack_public_path__ + "img/choose-up-Up Gradinita.bb1af55b.png";